import React from "react";
import Switch from '@mui/material/Switch';


const SwitchCustom = ({value, handleChange}) => {
    return (
        <Switch 
            checked={value}
            onChange={handleChange}
        />
    )
}

export default SwitchCustom